import { generateUrlBase } from "utils/utils";
import { getLocalAccessToken } from "Auth/auth/token";

import type { ApiCallerT } from "shared/infrastructure/api/types";
import type { ImportBalancesApiT, ImportBalancesResponseT } from "../types/importBalances.types";

const SCOPE_MAP: Record<"all" | "no-balances", number> = {
  "all": 0,
  "no-balances": 1,
};

const parseJwtPayload = (token: string) => {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(window.atob(base64));
  } catch {
    return {};
  }
};

export const createImportBalancesApi = (apiCaller: ApiCallerT): ImportBalancesApiT => ({
  importBalances: async ({ colaboraInstanceId, typeId, mode, externalTypeId }) => {
    const authToken = getLocalAccessToken();
    const tokenClaims = parseJwtPayload(authToken ?? "");
    const companyState = JSON.parse(sessionStorage.getItem("companyState") ?? "{}");

    const url = generateUrlBase("vacation-accrual/initial-balance/import");

    const response = await apiCaller<ImportBalancesResponseT>(
      url,
      "POST",
      {
        scope: SCOPE_MAP[mode],
        origin: externalTypeId,
      },
      {},
      {
        instanceId: colaboraInstanceId,
        companyId: companyState?.companyId,
        licenseId: tokenClaims?.extension_LicenseID,
        identityId: tokenClaims?.oid,
        authToken: authToken,
      },
    );

    return response;
  },
});
